<template>
  <div class="custom-widget">
    <navigator
      v-if="item.type === 1"
      :count="item.data.count"
      :items="item.data.items"
      :showTitle="item.data.showTitle"
      :textColor="item.data.textColor"
    />
    <interlayer
      v-else-if="item.type === 4"
      :type="item.data.type"
      :data="item.data"
    />
    <images-widget
      v-else-if="item.type === 3"
      :type="item.data.type"
      :items="item.data.items"
      :round="item.data.round"
      :shadow="item.data.shadow"
    ></images-widget>
    <image-bar v-else-if="item.type === 2" :image="item.data.image"></image-bar>
  </div>
</template>
<script>
export default {
  name: "CustomWidget",
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="less" scoped>
.custom-widget {
  position: relative;
}
// .custom-widget::after {
//   position: absolute;
//   bottom: 0;
//   display: block;
//   content: "";
//   width: 100%;
//   height: 1px;
//   background-color: #0000ed;
//   transform: scaleY(0.3);
// }
</style>